export const EVENTS = {
  PAGE_VIEW: 'PAGE_VIEW',
  TAP_PROCEED_TO_PAYMENT: 'TAP_PROCEED_TO_PAYMENT',
  TAP_ON_FIELD: 'TAP_ON_FIELD',
  FOUCUS_OUT_OF_FIELD: 'FOUCUS_OUT_OF_FIELD',
  CLICK: 'CLICK',

  // SEMAGLUTIDE
  OTP_RECEIVED: 'otp_received',
  OTP_VERIFIED: 'otp_verified',
  MY_SAATHI_REGISTRATION_SUCCESS: 'mysaathi_registration_success_landing',
  MY_SAATHI_ADDRESS_CONTINUE_CLICKED: 'address_continue_clicked',
  MY_SAATHI_DOCTOR_DETAILS_CONTINUE_CLICKED: 'doctor_details_continue_clicked',
  LANDING_ON_ONBOARDING_SCREEN: 'landing_on_onboarding_screen',
}
